import { render, staticRenderFns } from "./purchaseItem.vue?vue&type=template&id=7f293146&scoped=true&"
import script from "./purchaseItem.vue?vue&type=script&lang=js&"
export * from "./purchaseItem.vue?vue&type=script&lang=js&"
import style0 from "./purchaseItem.vue?vue&type=style&index=0&id=7f293146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f293146",
  null
  
)

export default component.exports